
















import BaseComponent from '@/components/base-component.vue';
import BagModelPrescription from '@/components/prescription/bag-model-prescription.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as resize from "@/subjects/resize";

@Component({
  components: {    
    BagModelPrescription,
    PermissionAuth
  },
})
export default class BagModelDetailsPrescButton extends BaseComponent {  
  @Prop()
  public id;

  show = false;

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  exibirGraficoBolsa() {
    this.show = true;
  }
}
